<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="车牌号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入车牌号查询" v-model="queryParam.plateNumber"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select placeholder="请选择状态" allow-clear v-model="queryParam.status">
                    <a-select-option value="idle">空闲</a-select-option>
                    <a-select-option value="using">使用中</a-select-option>
                    <a-select-option value="repair">维修</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="12" :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                  <a-button v-if="btnEnableList.indexOf(5)>-1" style="margin-left: 8px" v-print="'#vehicleListPrint'" icon="printer">打印</a-button>
                </a-col>
              </span>
            </a-row>
          </a-form>
        </div>
        <div class="table-operator" style="margin-top: 5px">
          <a-button v-if="btnEnableList.indexOf(1)>-1" type="primary" icon="plus" @click="handleAdd">新增</a-button>
          <a-button v-if="btnEnableList.indexOf(1)>-1" icon="delete" @click="batchDel">删除</a-button>
          <a-button v-if="btnEnableList.indexOf(3)>-1" icon="download" @click="handleExport">导出</a-button>
        </div>
        <section ref="print" id="vehicleListPrint">
          <a-table
            ref="table"
            size="middle"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="false"
            :scroll="scroll"
            :loading="loading"
            :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
            @change="handleTableChange">
            <span slot="action" slot-scope="text, record">
              <a @click="handleDetail(record)">详情</a>
              <a-divider v-if="btnEnableList.indexOf(1)>-1" type="vertical" />
              <a @click="handleEdit(record)">编辑</a>
              <a-divider v-if="btnEnableList.indexOf(1)>-1" type="vertical" />
              <a-popconfirm v-if="btnEnableList.indexOf(1)>-1" title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                <a>删除</a>
              </a-popconfirm>
            </span>
            <template slot="customRenderStatus" slot-scope="text, record">
              <a-tag v-if="record.status === 'idle'" color="green">空闲</a-tag>
              <a-tag v-if="record.status === 'using'" color="blue">使用中</a-tag>
              <a-tag v-if="record.status === 'repair'" color="orange">维修</a-tag>
            </template>
          </a-table>
        </section>
        <a-pagination
          style="margin-top: 16px; text-align: right"
          :current="ipagination.current"
          :pageSize="ipagination.pageSize"
          :total="ipagination.total"
          @change="paginationChange"
          @showSizeChange="paginationShowSizeChange"
        />
        <vehicle-modal ref="modalForm" @ok="modalFormOk"></vehicle-modal>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import VehicleModal from './VehicleModal'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

export default {
  name: 'VehicleList',
  mixins: [JeecgListMixin],
  components: {
    VehicleModal
  },
  data() {
    return {
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18,
        offset: 1
      },
      urlPath: '/plugin/vehicle/list',
      queryParam: {
        plateNumber: '',
        status: ''
      },
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: "center",
          customRender: function(t, r, index) {
            return parseInt(index) + 1;
          }
        },
        {
          title: '车牌号',
          dataIndex: 'plateNumber',
          width: 120
        },
        {
          title: '品牌',
          dataIndex: 'brand',
          width: 100
        },
        {
          title: '型号',
          dataIndex: 'model',
          width: 120
        },
        {
          title: '颜色',
          dataIndex: 'color',
          width: 80
        },
        {
          title: '车辆类型',
          dataIndex: 'vehicleType',
          width: 100
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: 100,
          align: "center",
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '备注',
          dataIndex: 'remark'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 200,
          align: "center",
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/api/plugin/vehicle-plugin/plugin-vehicle/list',
        delete: '/api/plugin/vehicle-plugin/plugin-vehicle/delete',
        deleteBatch: '/api/plugin/vehicle-plugin/plugin-vehicle/deleteBatch'
      }
    }
  },
  methods: {
    handleDetail(record) {
      this.$message.info('查看详情：' + record.plateNumber)
    },
    handleExport() {
      this.$message.info('导出功能开发中...')
    },
    paginationChange(current, pageSize) {
      this.ipagination.current = current
      this.ipagination.pageSize = pageSize
      this.loadData()
    },
    paginationShowSizeChange(current, pageSize) {
      this.ipagination.current = 1
      this.ipagination.pageSize = pageSize
      this.loadData()
    }
  }
}
</script>
<style scoped>
.table-page-search-wrapper { margin-bottom: 15px; }
.table-operator { margin-bottom: 15px; }
</style>
